<template>
  <box-model title="摄像头">
    <template v-slot:content>
      <div class="container flex-y-center">
        <div id="caechart" class="con"></div>
        <div class="show-part flex-y-center">
          <div class="sm">
            <div class="s-title">摄像头数量</div>
            <div class="s-con">{{ detail.num || '--' }}<span class="t">个</span></div>
          </div>
        </div>
        <div class="show-txt flex-direction-sty">
          <div class="txt-item flex-y-center">
            <div class="t-cyc"></div>
            <div>正常</div>
            <div class="t-num">{{ detail.normalNum || '--' }}</div>
            <span>个</span>
          </div>
          <div class="txt-item flex-y-center">
            <div class="t-cyc1"></div>
            <div>异常</div>
            <div class="t-num">{{ detail.errorNum || '--' }}</div>
            <span>个</span>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import echarts from 'echarts';
  import { getLiveCount } from "@/api/index";
  export default {
    data() {
      return {
        detail: {}
      }
    }, 
    components: {
      "box-model": () => import("../../components/common/Model.vue")
    },
    mounted(){
      this.getLiveCountFn();
    },
    methods: {
      getLiveCountFn() {
        getLiveCount().then((res) => {
          this.detail = res.data || {};
          this.initFn();
        });
      },
      initFn() {
        let that = this;
        let option = {
          tooltip : {
            trigger: 'item',
            formatter: function(item){
              let result = `
                <div style="padding: 12px;z-index:9999;position:relative;">
                  <div style="color: #3E3E3E;font-size: 13px;">${item.name}</div>
                  <div style="width: 100%;height: 1px;background: #E8E8EA;margin:8px 0; "></div>
                  <div style="display: flex;align-items: center;">
                    <div style="width: 8px;height: 8px;background: ${item.color};border-radius: 50%;"></div>
                    <div style="color: #000E2B;font-size: 13px;margin-left: 4px;line-height: 16px;">数量：${item.value}个</div>  
                  </div>
                </div>
              `;
              return result;
            },
            backgroundColor: '#fff',
          },
          color:['#06F7A1','#FF6637','#00ccff','#ffcc00','#f5e965','#a74faf'],
          series: [
            {
              name: '资源总量构成',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['50%', '60%'],
              data: [
                {id: 1, name: '正常', value: that?.detail?.normalNum || 0},
                {id: 2, name: '异常', value: that?.detail?.errorNum || 0},
              ],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              itemStyle: {
                normal: {
                  label:{ 
                    show: false, 
                    formatter: '{b}\n{d}%',
                    fontSize : 12,
                  }
                },
                labelLine :{show:false}
              }
            }
          ]
        };
        const myChart = echarts.init(document.getElementById("caechart"));
        myChart.setOption(option);
      }
    }
  }
</script>
<style scoped lang="less">
  .flex-y-center {
    display: flex;
    align-items: center;
  }
  .flex-direction-sty {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .container {
    position: relative;
    width: 100%;
    height: 228px;
    
    .con {
      position: relative;
      z-index: 0;
      width: 200px;
      height: 200px;
    }
    .show-part {
      position: absolute;
      z-index: 999;
      top: 50%;
      transform: translateY(-50%);
      left: 80px;
      .sm {
        width: 100%;
        .s-title {
          font-size: 18px;
          font-weight: 400;
          color: rgba(255,255,255,0.702);
          line-height: 15px;
          text-align: center;
        }
        .s-con {
          font-size: 24px;
          font-weight: 700;
          color: #FFFFFF;
          line-height: 22px;
          text-align: center;
          margin-top: 10px;
          .t {
            font-size: 18px;
            font-weight: 400;
            color: #FFFFFF;
            margin-left: 6px;
          }
        }
      }
    }
    .show-txt {
      position: absolute;
      z-index: 999;
      width: 120px;
      height: 200px;
      right: 60px;
      top: 50%;
      transform: translateY(-50%);
      .txt-item {
        height: 20px;
        font-size: 20px;
        font-weight: 400;
        color: #FFFFFF;
        margin-bottom: 20px;
        .t-num {
          font-size: 24px;
          font-weight: 400;
          color: #4ADDFF;
          margin-left: auto;
          margin-right: 6px;
        }
        .t-cyc {
          width: 8px;
          height: 8px;
          background: #06F7A1;
          border-radius: 50%;
          margin-right: 10px;
        }
        .t-cyc1 {
          width: 8px;
          height: 8px;
          background: #FF6637;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      .txt-item:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>